/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = StandaloneDocument

1 = Bid

2 = EmailMessage

3 = JobProposal

4 = LeadProposal

5 = PurchaseOrder

6 = UserActivation

7 = Receipt

8 = OwnerInvoiceAnonymous

9 = LienWaivers

10 = LeadProposalPDFGeneration

11 = JobProposalPDFGeneration

12 = OwnerInvoice

13 = UserScheduleConfirmation

14 = OnlinePayment

15 = PurchaseOrderPDFGeneration

16 = LienWaiverPDFGeneration

17 = OutboundPayment

18 = Deposit

19 = MicrodepositVerification

20 = DepositAnonymous

21 = ChangeEmail

22 = CalendarFeed

23 = POStatusChange

24 = JobIterativeProposal

25 = ProofOfPurchase

26 = SubBankAccount

27 = OwnerSurvey

28 = Task

29 = SpecificationBook

30 = Submittal

31 = Plans

32 = TaskBulkPrint

33 = SubmittalPrint

34 = SubmittalExternalReview


 */
export type SharedEntityType =
  (typeof SharedEntityType)[keyof typeof SharedEntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharedEntityType = {
  StandaloneDocument: 0,
  Bid: 1,
  EmailMessage: 2,
  JobProposal: 3,
  LeadProposal: 4,
  PurchaseOrder: 5,
  UserActivation: 6,
  Receipt: 7,
  OwnerInvoiceAnonymous: 8,
  LienWaivers: 9,
  LeadProposalPDFGeneration: 10,
  JobProposalPDFGeneration: 11,
  OwnerInvoice: 12,
  UserScheduleConfirmation: 13,
  OnlinePayment: 14,
  PurchaseOrderPDFGeneration: 15,
  LienWaiverPDFGeneration: 16,
  OutboundPayment: 17,
  Deposit: 18,
  MicrodepositVerification: 19,
  DepositAnonymous: 20,
  ChangeEmail: 21,
  CalendarFeed: 22,
  POStatusChange: 23,
  JobIterativeProposal: 24,
  ProofOfPurchase: 25,
  SubBankAccount: 26,
  OwnerSurvey: 27,
  Task: 28,
  SpecificationBook: 29,
  Submittal: 30,
  Plans: 31,
  TaskBulkPrint: 32,
  SubmittalPrint: 33,
  SubmittalExternalReview: 34,
} as const;
